// extracted by mini-css-extract-plugin
export default {"container":"LazyImage_container__Z+lvw","cover":"LazyImage_cover__26cph","loading":"LazyImage_loading__TLuDl"};